import { Loader, Paper, Text } from "@mantine/core"
import { useQuery } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"

import { queries } from "@/lib/queries"

export const Route = createFileRoute("/hub/documents")({
  component: Documents,
})

function Documents() {
  const { data, isPending } = useQuery(queries.documents())

  return (
    <Paper withBorder p="lg" radius={0} style={{ borderColor: "var(--pitch-border)" }}>
      {isPending ? (
        <Loader size="sm" />
      ) : !data || data.length === 0 ? (
        <Text c="var(--pitch-text-tertiary)">No documents available yet. Check back after the first LP close.</Text>
      ) : (
        <Text c="var(--pitch-text-primary)">Document repository — {data.length} documents</Text>
      )}
    </Paper>
  )
}
